import React, { useEffect, useState } from "react";
import { Modal, Button, Row, Col, Divider, Input, Form, Radio, RadioChangeEvent, Checkbox } from "antd";
import { CloseCircleOutlined, PlusOutlined, SaveOutlined } from "@ant-design/icons";
import "./NewBuyerForm.css";

export interface NewBuyerFormProps {
  showForm: boolean;
  closeForm: () => void;
  editBuyerData: any;
  postBuyer: (buyerInfo: any) => void;
  putBuyer?: (buyerInfo: any) => void;
}

const NewBuyerForm = (props: NewBuyerFormProps) => {
  const [buyerInfo, setBuyerInfo] = useState({
    name: "",
    companyName: "",
    identificationCardNumber: "",
    contactNumber: "",
    emailAddress: "",
    address: "",
    companyCode: "",
    passportNumber: "",
    pgOffice: false,
    bwOffice: false,
  });
  const [nameFormStatus, setNameFormStatus] = useState("") as any;
  const [nameFormMessage, setNameFormMessage] = useState("");
  const [companyNameFormStatus, setCompanyNameFormStatus] = useState("") as any;
  const [companyNameFormMessage, setCompanyNameFormMessage] = useState("");
  const [identificationCardNumberFormStatus, setIdentificationCardNumberFormStatus] = useState("") as any;
  const [identificationCardNumberFormMessage, setIdentificationCardNumberFormMessage] = useState("");
  const [passportFormStatus, setPassportFormStatus] = useState("") as any;
  const [passportFormMessage, setPassportFormMessage] = useState("");
  const [officeFormStatus, setOfficeFormStatus] = useState("") as any;
  const [officeFormMessage, setOfficeFormMessage] = useState("");
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);

  useEffect(() => {
    console.log("run");
    if (props.editBuyerData !== null) {
      setBuyerInfo(props.editBuyerData);
    }
  }, [props.editBuyerData]);

  const updateName = (value: any) => {
    setNameFormStatus("");
    setNameFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.name = value;
    setBuyerInfo(buyer);
  };

  const updateCompanyName = (value: any) => {
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.companyName = value;
    setBuyerInfo(buyer);
  };

  const updateIdentificationCardNumber = (value: any) => {
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.identificationCardNumber = value;
    setBuyerInfo(buyer);
  };

  const updatePassportNumber = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.passportNumber = value;
    setBuyerInfo(buyer);
  };

  const updateContactNumber = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.contactNumber = value;
    setBuyerInfo(buyer);
  };

  const updateEmailAddress = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.emailAddress = value;
    setBuyerInfo(buyer);
  };

  const updateAddress = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.address = value;
    setBuyerInfo(buyer);
  };

  const updateCompanyCode = (value: any) => {
    let buyer = { ...buyerInfo };
    buyer.companyCode = value;
    setBuyerInfo(buyer);
  };

  const updateOffice = (checkedValues: any[]) => {
    setOfficeFormStatus("");
    setOfficeFormMessage("");
    let buyer = { ...buyerInfo };
    buyer.bwOffice = checkedValues.includes("Butterworth ( BW )") ? true : false;
    buyer.pgOffice = checkedValues.includes("Penang ( PG )") ? true : false;
    setBuyerInfo(buyer);
  };

  const closeForm = () => {
    resetBuyerInfo();
    props.closeForm();
  };

  const validateForm = () => {
    let buyer = { ...buyerInfo };
    let validationFormStatus = true;
    if (buyer.name === "") {
      validationFormStatus = false;
      setNameFormStatus("error");
      setNameFormMessage("Name must be entered");
    }
    const formatICNumber = buyer.identificationCardNumber.replaceAll(" ", "").replaceAll("-", "");
    if (formatICNumber === "") {
      setIdentificationCardNumberFormStatus("");
      setIdentificationCardNumberFormMessage("");
    } else if (formatICNumber.length > 0 && formatICNumber.length !== 12) {
      validationFormStatus = false;
      setIdentificationCardNumberFormStatus("error");
      setIdentificationCardNumberFormMessage("IC must be 12 numbers");
    }
    if (buyer.pgOffice === false && buyer.bwOffice === false) {
      validationFormStatus = false;
      setOfficeFormStatus("error");
      setOfficeFormMessage("Select at least one office");
    }
    return validationFormStatus;
  };

  const openCancelBuyerModal = () => {
    setIsCancelModalOpen(true);
  };

  const confirmCancelBuyer = () => {
    resetBuyerInfo();
    setIsCancelModalOpen(false);
    closeForm();
  };

  const declineCancelBuyer = () => {
    setIsCancelModalOpen(false);
  };

  const resetBuyerInfo = () => {
    setBuyerInfo({
      name: "",
      companyName: "",
      identificationCardNumber: "",
      contactNumber: "",
      emailAddress: "",
      address: "",
      companyCode: "",
      passportNumber: "",
      pgOffice: false,
      bwOffice: false,
    });
    setNameFormStatus("");
    setNameFormMessage("");
    setCompanyNameFormStatus("");
    setCompanyNameFormMessage("");
    setIdentificationCardNumberFormStatus("");
    setIdentificationCardNumberFormMessage("");
    setOfficeFormStatus("");
    setOfficeFormMessage("");
  };

  const saveBuyerInfo = () => {
    props.putBuyer && props.putBuyer(buyerInfo);
    closeForm();
  };

  const addBuyerInfo = () => {
    props.postBuyer(buyerInfo);
    closeForm();
  };

  const getDefaultCheckboxValue = () => {
    let checkboxValue = [""];
    if (props.editBuyerData !== null && props.editBuyerData.pgOffice) checkboxValue.push("Penang ( PG )");
    if (props.editBuyerData !== null && props.editBuyerData.bwOffice) checkboxValue.push("Butterworth ( BW )");
    return checkboxValue;
  };

  return props.showForm ? (
    <Row justify="center">
      <div className="new-buyer-form">
        <Row>
          <Col span={20}>
            <Row justify="start">New Buyer</Row>
          </Col>
          <Col span={4}>
            <Row justify="end">
              <CloseCircleOutlined onClick={() => openCancelBuyerModal()} />
            </Row>
          </Col>
        </Row>
        <Row>
          <Divider style={{ margin: "12px 0" }} />
        </Row>
        <Form layout="vertical">
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Full Name</label>}
                  validateStatus={nameFormStatus}
                  help={nameFormMessage}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="Name"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={buyerInfo.name}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateName(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item label={<label className="buyer-form-label">Company Name</label>} style={{ width: "100%" }}>
                  <Input
                    placeholder="Company Name"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={buyerInfo.companyName}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateCompanyName(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Identification Number (IC Number)</label>}
                  validateStatus={identificationCardNumberFormStatus}
                  help={identificationCardNumberFormMessage}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="000000-00-0000"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={buyerInfo.identificationCardNumber}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateIdentificationCardNumber(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Passport Number</label>}
                  style={{ width: "100%" }}
                >
                  <Input
                    placeholder="Passport Number"
                    style={{ width: "100%", marginBottom: "10px", marginRight: "5px" }}
                    value={buyerInfo.passportNumber}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updatePassportNumber(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Select Office</label>}
                  validateStatus={officeFormStatus}
                  help={officeFormMessage}
                >
                  <Checkbox.Group
                    options={["Butterworth ( BW )", "Penang ( PG )"]}
                    defaultValue={getDefaultCheckboxValue()}
                    // defaultValue={["Butterworth ( BW )", "Penang ( PG )"]}
                    onChange={updateOffice}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          {/* <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Phone Number</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateContactNumber(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Email Address</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateEmailAddress(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Address</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateAddress(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row>
          <Row align="middle">
            <Col span={24}>
              <Row align="middle">
                <Form.Item
                  label={<label className="buyer-form-label">Company Code</label>}
                  //   validateStatus={wasteWeightFormStatus}
                  //   help={wasteWeightFormMessage}
                >
                  <Input
                    placeholder="0.0"
                    style={{ width: "150px", marginBottom: "10px", marginRight: "5px" }}
                    // value={materialInfo.wasteWeight}
                    onClick={(e) =>
                      e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
                    }
                    onChange={(e) => updateCompanyCode(e.target.value)}
                  />
                </Form.Item>
              </Row>
            </Col>
          </Row> */}
        </Form>
        <Row justify="center" style={{ marginTop: "20px" }}>
          <Button className="cancel-button" onClick={() => openCancelBuyerModal()}>
            Cancel
          </Button>
          <Button
            type="primary"
            icon={props.editBuyerData ? <SaveOutlined /> : <PlusOutlined />}
            onClick={() => (props.editBuyerData ? validateForm() && saveBuyerInfo() : validateForm() && addBuyerInfo())}
          >
            {props.editBuyerData ? "Save" : "Add Buyer"}
          </Button>
        </Row>
      </div>
      <Modal
        title="Cancel Buyer Add"
        open={isCancelModalOpen}
        okText="Confirm"
        okType="danger"
        onOk={confirmCancelBuyer}
        onCancel={declineCancelBuyer}
      >
        <p>Are you sure you want to cancel?</p>
        <p>Your changes will not be saved.</p>
      </Modal>
    </Row>
  ) : null;
};

export default NewBuyerForm;
